import React from "react";
import RiskLevels from "../../risk/RiskLevels";

/** Admin > Risk Assessment: probability & impact levels (same as /risk_levels body). */
function RiskAssessmentScreen({ company_id = null, hideHeader = false }) {
  const companyId = Number(company_id);
  return <RiskLevels company_id={companyId} hideHeader={hideHeader} />;
}

export default RiskAssessmentScreen;
